import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const InternalLinkIcon: FunctionComponent<IconProps> = ({ size }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size ? size : 24}
    height={size ? size : 24}
    fill='none'
    viewBox='0 0 24 24'
  >
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      d='M5 12h14M16 9l3 3-3 3'
    ></path>
  </svg>
)

export default InternalLinkIcon;
